<template>
  <v-combobox
    :search-input.sync="search"
    :label="label"
    :prepend-icon="prepend_icon"
    :append-icon="append_icon"
    clearable
    :items="filteredItems"/>
</template>
<script>

import Debounce from '@/components/mixins/Debounce';

export default {
  props:['st_key','item_key','label'/* ,'return_object' */,'value','prepend_icon','append_icon','listToSearch'],
  mixins: [ Debounce ],
  data() {
    return {
      search: '',
      filteredItems: [],
    };
  },
  computed: {
    list(){return this.listToSearch || this.$store.getters[this.st_key]},
    items(){ return this.list.map(u => u[this.item_key])},
/*     searchUserObj(){
      if (!this.return_object) return {};
      if (this.filteredItems.length === 1) {
        return this.list.find(u => u[this.item_key] === this.filteredItems[0]) || {};
      }
      return {};
    }, */
  },
  watch: {
    search(v){
      const callb = ()=>this.upd(v)
      this.debounceM('search', this.filter,callb);
      
      
    },
  },
  methods: {
    upd(){
      this.$emit('update:value', /* this.return_object ? this.searchUserObj: */this.search)
    },
    async filter(extraFilters, page){
      const search = this.search ? this.search.toLowerCase() : null;
      this.filteredItems = this.items.filter(f => (f || '').toLowerCase().includes(search))
		},
  },
};
</script>
